import WhiteCar from "../assets/img/ic_car_white.png";
import TrailerWhite from "../assets/img/ic_trailer_white.png";
import ComplaintWhite from "../assets/img/ic_complaint_white.png";
import PolicyWhite from "../assets/img/ic_policy_white.png";
import MechanicAssistance from "../assets/img/ic_mechanic_assistance.png"

export const GENERAL_NOTIFICATION = "general";
export const INSPECTION_NOTIFICATION = "inspection";
export const ASSISTANCE_NOTIFICATION = "assistance";
export const COMPLAINT_NOTIFICATION = "complaint";
export const POLICY_NOTIFICATION = "policy";
export const INCIDENT_NOTIFICATION = "incident";
export const MECHANIC_ASSISTANCE = "mechanic_assistance"

export const iconTypes: any = {
  [GENERAL_NOTIFICATION]: WhiteCar,
  [INSPECTION_NOTIFICATION]: WhiteCar,
  [ASSISTANCE_NOTIFICATION]: TrailerWhite,
  [COMPLAINT_NOTIFICATION]: ComplaintWhite,
  [POLICY_NOTIFICATION]: PolicyWhite,
  [INCIDENT_NOTIFICATION]: ComplaintWhite,
  [MECHANIC_ASSISTANCE] : MechanicAssistance,
};
